import { config } from "../config/env";
import type { ApiResponse } from "../types/api";
import type { PublicStatusResult } from "../types/status";

const API_BASE_URL = config.apiBaseUrl;

export async function fetchPublicStatus(): Promise<PublicStatusResult> {
  const response = await fetch(`${API_BASE_URL}/status`, {
    headers: {
      Accept: "application/json",
    },
  });
  const payload: ApiResponse<PublicStatusResult> = await response.json();

  if (!payload.data) {
    throw new Error(
      payload.error || payload.message || "Status feed unavailable",
    );
  }

  return payload.data;
}
